
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWaypointAddIec as ObiWaypointAddIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-waypoint-add-iec.js';
 
 
 

 
 export const ObiWaypointAddIec = createComponent({
   react: React,
   tagName: 'obi-waypoint-add-iec',
   elementClass: ObiWaypointAddIecElement,
   events: {
     
   }
  });
 
 